<c-breadcrumb [style]="'--cui-breadcrumb-divider:\'>\''" class="mb-4 breadCrumbList">
  <ng-container *ngFor="let item of items; let last = last">
    <c-breadcrumb-item [active]="last" [url]="item?.url">{{ item?.label }}</c-breadcrumb-item>
  </ng-container>
</c-breadcrumb>
